module.exports = __webpack_public_path__ + "img/3.78443af1.png";